<template>
  <nav class="uk-navbar-container uk-margin" uk-navbar>
    <div class="uk-navbar-center">
      <a class="uk-navbar-item uk-logo" href="/dashboard">
        <img src="@/assets/logo.png">
      </a>
    </div>
  </nav>
</template>
